<div class="my-5">
  <h5 class="mb-4">{{ 'externalEmployees.masterData.employeeDetails.title' | translate }}</h5>
  <div
    class="row"
    *ngIf="!offer?.anonymous || offer?.status === offerStatuses.confirmed"
  >
    <p class="col-3 fw-bold">{{ 'dateOfBirth' | translate }}</p>
    <p class="col-9">{{ offer?.profile?.dateOfBirth | baseFormatDate | baseIsEmpty }}</p>
  </div>
  <div class="row">
    <p class="col-3 fw-bold">
      {{ 'externalEmployees.masterData.employeeDetails.distanceToLocation' | translate }}
    </p>
    <p class="col-9">{{ distanceLabel | baseIsEmpty }}</p>
  </div>
  <div class="row">
    <p class="col-3 fw-bold">{{ 'provider' | translate }}</p>
    <p class="col-9">{{ offer?.psp?.legalName }}, {{ offer?.pspBranch?.legalName }}</p>
  </div>
  <div
    class="row"
    *ngIf="!offer?.anonymous || offer?.status === offerStatuses.confirmed"
  >
    <p class="col-3 fw-bold">{{ 'externalEmployees.masterData.employeeDetails.staffId' | translate }}</p>
    <p class="col-9">{{ offer?.profile?.staffId | baseIsEmpty }}</p>
  </div>
</div>

<base-customer-shift-readiness
  class="my-5"
  [profile]="offer?.profile"
></base-customer-shift-readiness>

<div class="my-5">
  <h5 class="mb-4">{{ 'qualifications.singular' | translate }}</h5>
  <div class="row">
    <p class="col-3 fw-bold">{{ 'externalEmployees.masterData.qualifications.primary' | translate }}</p>
    <p class="col-9 main-qualification-text">{{ offer?.profile?.mainQualification?.name }}</p>
  </div>
  <div class="row">
    <p class="col-3 fw-bold">{{ 'externalEmployees.masterData.qualifications.secondary' | translate }}</p>
    <div class="col-9">
      <div
        class="row"
        *ngFor="let qualification of offer?.profile?.qualifications"
      >
        <span class="mb-1 alternative-qualification-text">{{ qualification.name }}</span>
      </div>
    </div>
  </div>
</div>

<div class="my-5">
  <h5 class="mb-4">{{ 'work.conditions.alt' | translate }}</h5>
  <div
    class="row mb-2"
    *ngFor="let category of inquiryRequirementCategories"
  >
    <p class="col-3 fw-bold">{{ category.name }}</p>
    <div class="col-9">
      <div
        class="d-flex align-items-center gap-2"
        *ngFor="let requirement of category.requirements"
      >
        <i
          class="fa-solid me-1"
          [ngClass]="
            hasRequirementInCategories(candidateRequirementCategories, requirement.id)
              ? 'fa-check text-success'
              : 'fa-xmark text-danger'
          "
        ></i>
        <span class="mb-1">{{ requirement.name }}</span>
      </div>
    </div>
  </div>
  <base-empty-list-row
    *ngIf="!inquiryRequirementCategories.length"
    message="inquiry.noRequirementsStored"
    [backgroundSecondary]="true"
    [hideBackgroundImage]="true"
  ></base-empty-list-row>
</div>

<div
  class="collapsable-content my-3 w-96"
  baseCollapsableContent
>
  <div class="collapsable-header arrow-end">
    <h5 baseTruncate>{{ 'work.conditions.other' | translate }}</h5>
  </div>
  <div class="collapsable-body px-2">
    <div
      class="row mb-2"
      *ngFor="let category of candidateRequirementCategories"
    >
      <p
        class="col-3 fw-bold"
        *ngIf="!inquiryContainsCategoryRequirements(category)"
      >
        {{ category.name }}
      </p>
      <div class="col-9">
        <div
          class="row"
          *ngFor="let requirement of category.requirements"
        >
          <span
            class="mb-1"
            *ngIf="!hasRequirementInCategories(inquiryRequirementCategories, requirement.id)"
            >{{ requirement.name }}</span
          >
        </div>
      </div>
    </div>
    <base-empty-list-row
      *ngIf="!candidateRequirementCategories.length"
      message="inquiry.noAdditionalRequirementsStored"
      [backgroundSecondary]="true"
      [hideBackgroundImage]="true"
    ></base-empty-list-row>
  </div>
</div>

<div
  class="my-5"
  *ngIf="hasAdminAssignmentsPermission && (!offer?.anonymous || offer?.status === offerStatuses.confirmed)"
>
  <h5 class="mb-4">{{ 'externalEmployees.masterData.recentAssignments.title' | translate }}</h5>
  <div class="listview">
    <div class="listview-header row">
      <div class="col-4">
        <span baseTruncate>{{ 'inquiry.period' | translate }}</span>
      </div>
      <div class="col-3">
        <span baseTruncate>{{ 'department.singular' | translate }}</span>
      </div>
      <div class="col-4">
        <span baseTruncate>{{ 'qualifications.singular' | translate }}</span>
      </div>
    </div>
    <div
      *ngFor="let endedAssignment of endedAssignments"
      class="listview-item bg-lightest mb-5"
    >
      <div class="row">
        <div class="col-4">
          <span>{{ endedAssignment.startDate | baseFormatDate }} - {{ endedAssignment.endDate | baseFormatDate }}</span>
        </div>
        <div class="col-3">
          <p class="mb-0">{{ endedAssignment.customerDepartment.name }}</p>
          <p class="text-dark-gray mb-0">{{ endedAssignment.customerLocation.name }}</p>
        </div>
        <div class="col-4">
          <span class="qualification-text-color">{{ endedAssignment.mainQualification.name }}</span>
        </div>
      </div>
    </div>

    <base-empty-list-row
      *ngIf="!endedAssignments.length"
      message="externalEmployees.masterData.recentAssignments.emptyList"
      [hideBackgroundImage]="true"
      [backgroundSecondary]="true"
    ></base-empty-list-row>
  </div>
</div>
